import React from 'react';
import { Button } from '../ui/button';
import ShaderBackground from '../ShaderBackground';

const EmergencySplash = ({ onNext }) => {
  return (
    <div className="relative flex min-h-screen w-full items-center justify-center bg-black">
      {/* Fireman Photo Background - Enhanced Visibility */}
      <div 
        className="absolute inset-0 bg-center bg-no-repeat bg-cover opacity-60 z-0"
        style={{
          backgroundImage: "url('https://lh3.googleusercontent.com/aida-public/AB6AXuAtNXMSLdZE2P_fR8ZsyYBVZ19Jr22xH4dprdcTgI1RNKTIBEDhu0f_h9HdVvGzEE3aemuIfCr-fU02-3rqG6hJ-YlEa_pL-CQcbqIIPnui-bfBwoOfQLsYRmjiLibPXLPJbyLhsl13OPNAYiYDUgD7Kd9N3ABPbIXmB2q3xQBLueWFZBQi_RKCKjET5gbk42NBoAObPDqAns31DOZxAX4NmVDHKmxD2Z5pHCq3VNoKMyBTCY-cY9iUQTpkQ_zqslsS5bdie1ARyPQ')",
          filter: 'brightness(1.3) contrast(1.2) saturate(1.4)'
        }}
      />
      
      {/* Orange overlay for warmth */}
      <div className="absolute inset-0 bg-gradient-to-b from-orange-900/20 via-transparent to-orange-600/30 z-[1]"></div>
      
      {/* Shader Animation Background */}
      <div className="absolute inset-0 z-[2]">
        <ShaderBackground />
      </div>
      
      {/* Slight dark overlay for text contrast */}
      <div className="absolute inset-0 bg-black/30 z-[3]"></div>
      
      {/* Mobile Container */}
      <div className="relative z-10 w-full max-w-sm mx-auto px-6 py-8">
        <div className="flex flex-col min-h-screen justify-between">
          {/* Content */}
          <div className="flex-grow flex items-center justify-center">
            <div className="w-full bg-black/50 backdrop-blur-md rounded-3xl p-8 border-2 border-orange-500/50 shadow-2xl">
              <h1 
                className="text-6xl font-black text-orange-500 tracking-tight mb-6 text-center"
                style={{
                  textShadow: '0 0 30px rgba(249, 115, 22, 1), 0 0 60px rgba(249, 115, 22, 0.6), 0 4px 12px rgba(0, 0, 0, 1)'
                }}
              >
                Skinopathy
              </h1>
              <p 
                className="text-lg text-orange-100 font-semibold text-center leading-relaxed"
                style={{
                  textShadow: '0 2px 10px rgba(0, 0, 0, 1), 0 0 20px rgba(0, 0, 0, 0.8)'
                }}
              >
                Designed by Drs. Hong and Wong, Our Clinical Team and AI & IT Team
              </p>
            </div>
          </div>
          
          {/* Button */}
          <div className="mt-8">
            <Button
              onClick={onNext}
              className="w-full h-16 px-6 rounded-2xl bg-orange-500 text-white text-xl font-black shadow-2xl hover:bg-orange-600 focus:outline-none focus:ring-4 focus:ring-orange-400 transition-all border-2 border-orange-400"
            >
              Start Assessment
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmergencySplash;